import {
	fetchData,
	getOneItem,
	updateItemFile,
	updateItemJson,
} from "../../../../Api/hotelEndpoint";
import { createAsyncThunk } from "@reduxjs/toolkit";
import socket from "../../../../Utils/socket";

/***------------- Get All Hotel Booking Data ------------- ***/
export const fetchHotelBooking = createAsyncThunk(
	"hotel/fetchHotelBooking",
	async (params, { rejectWithValue }) => {
		try {
			const { data, totalPages, totalItems, sumAmounts } = await fetchData({
				endpoint: "hotel/fetchAllHotelBooking",
				...params,
			});
			return { data, totalPages, totalItems, sumAmounts };
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Get All Hotel Booking Counts Data ------------- ***/
export const fetchHotelBookingCounts = createAsyncThunk(
	"hotel/getHotelBookingCounts",
	async ({ startDate, endDate }, { rejectWithValue }) => {
		try {
			const data = await getOneItem(
				`hotel/getHotelBookingCounts?startDate=${startDate}&endDate=${endDate}`
			);
			return data;
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Get One Hotel Booking Data ------------- ***/
export const fetchOneHotelBooking = createAsyncThunk(
	"hotel/fetchOneHotelBooking",
	async ({ id }, { rejectWithValue }) => {
		try {
			const data = await getOneItem("hotel/fetchOneHotelBooking", id);
			return data;
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Update One Hotel Booking Data ------------- ***/
export const updateHotelBooking = createAsyncThunk(
	"hotel/updateHotelBooking",
	async ({ id, bookingStatus, router, parStatus }, { rejectWithValue }) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/updateHotelBooking",
				formData: { bookingStatus },
				id,
			});
			if (data) {
				router(`/hotel/booking?status=${parStatus}`);
				socket.emit("new_booking");
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Confirm Hotel Booking with uploaded hotel voucher + purchase price ------------- ***/
export const confirmHotelBookingWithVoucher = createAsyncThunk(
	"hotel/confirmHotelBookingWithVoucher",
	async ({ id, formData, router, parStatus }, { rejectWithValue }) => {
		try {
			const data = await updateItemFile({
				endpoint: "hotel/confirmHotelBookingWithVoucher",
				formData,
				id,
			});
			if (data) {
				router(`/hotel/booking?status=${parStatus}`);
				socket.emit("new_booking");
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***-------------  Hotel upcoming Status update multi Booking Data ------------- ***/
export const upcomingRejectHotelBooking = createAsyncThunk(
	"hotel/upcomingRejectHotelBooking",
	async (formData, { rejectWithValue }) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/upcomingRejectHotelBooking",
				formData,
			});
			if (data) {
				socket.emit("new_booking");
				return formData?.ids;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- update Settlement Status ------------- ***/
export const generateHotelSettlement = createAsyncThunk(
	"hotel/updateSettlementStatus",
	async (
		{ ids, totals, bookingDetails, hotelId, selectedHotel },
		{ rejectWithValue }
	) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/updateSettlementStatus",
				formData: { ids, totals, bookingDetails, hotelId, selectedHotel },
			});
			if (data) {
				return ids;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Get All Hotel Settlement Data ------------- ***/
export const fetchHotelSettlement = createAsyncThunk(
	"hotel/fetchAllSettlement",
	async (params, { rejectWithValue }) => {
		try {
			const { data, totalPages, totalItems } = await fetchData({
				endpoint: "hotel/fetchAllSettlement",
				...params,
			});
			return { data, totalPages, totalItems };
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Get One Hotel oneSettlement Data ------------- ***/
export const fetchOneHotelSettlement = createAsyncThunk(
	"hotel/fetchOneHotelSettlement",
	async ({ id }, { rejectWithValue }) => {
		try {
			const data = await getOneItem("hotel/fetchOneHotelSettlement", id);
			if (data) {
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- update Settlement Status ------------- ***/
export const hotelPaymentDetailsGenerated = createAsyncThunk(
	"hotel/makePayment",
	async (params, { rejectWithValue }) => {
		try {
			const data = await updateItemFile({
				endpoint: "hotel/makePayment",
				formData: params,
			});
			if (data) {
				params.close();
				return params.settlementId;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Update One Hotel Booking CheckIn status ------------- ***/
export const updateHotelCheckInStatus = createAsyncThunk(
	"hotel/updateHotelCheckInStatus",
	async ({ id, checkInStatus }, { rejectWithValue }) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/updateHotelCheckInStatus",
				formData: { checkInStatus },
				id,
			});
			if (data) {
				return id;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Update One Hotel Booking Exchanged status ------------- ***/
export const exchangeHotelBooking = createAsyncThunk(
	"hotel/hotelExchanged",
	async ({ id }, { rejectWithValue }) => {
		try {
			const data = await getOneItem("hotel/exchangeHotelBooking", id);
			if (data) {
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Update One Hotel Booking CheckOut status ------------- ***/
export const updateHotelCheckOutStatus = createAsyncThunk(
	"hotel/updateHotelCheckOutStatus",
	async ({ id, checkOutStatus }, { rejectWithValue }) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/updateHotelCheckOutStatus",
				formData: { checkOutStatus },
				id,
			});
			if (data) {
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);

/***------------- Get today summary Data ------------- ***/
export const fetchTodaySummaryBooking = async (selectedDate) => {
	try {
		const data = await getOneItem(`hotel/today-summary?date=${selectedDate}`);
		return data;
	} catch (error) {
		throw error;
	}
};

/***------------- Update One Hotel Booking Refund ------------- ***/
export const updateHotelRefund = async (id, formData) => {
	try {
		const data = await updateItemFile({
			endpoint: "hotel/updateHotelRefundData",
			formData,
			id,
		});
		if (data) {
			return data;
		}
	} catch (error) {
		throw error;
	}
};


/***------------- Confirm Hotel Booking Enquiry ------------- ***/
export const confirmHotelBookingEnquiry = createAsyncThunk(
	"hotel/confirmHotelEnquiry",
	async ({ id, formData, router}, { rejectWithValue }) => {
		try {
			const data = await updateItemJson({
				endpoint: "hotel/confirmHotelEnquiry",
				formData: { ...formData },
				id,
			});
			if (data) {
				router(`/hotel/booking?status=enquiry`);
				socket.emit("new_booking");
				return data;
			}
		} catch (error) {
			return rejectWithValue(error.message);
		}
	}
);